import styled from "styled-components";
import PageTopTitle from "../../components/shared/PageTopTitle";
import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  aracBelgeAktiflikKontrol,
  faturaYukle,
  getFaturaImage,
} from "../../features/admin/adminSlice";
import { useState } from "react";
import Button from "../../components/shared/Button";
import SmallSpinner from "../../components/shared/spinners/SmallSpinner";
 
import Btn from "../../components/shared/button/Btn";
import { validateExcelFile } from "../../helper/docs/validateExcelFile";
import { validateFile } from "../../helper/docs/validateFile";
import { validateFileExceptPdf } from "../../helper/docs/validateFileExceptPdf";


const Container = styled.div`
  width: 100%;

  .wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;

    .content {
      display: flex;
      gap: 40px;
      width: 100%;
      padding: 30px;

      .content-item {
        width: calc(50% - 20px);
        height: auto;
        border: 1px solid;
        border-color: ${({ theme }) => theme.mainBorderColor};
        border-radius: 20px;
        overflow: hidden;

        h2 {
          text-align: center;
          padding: 15px;
          font-size: 18px;
          color: ${({ theme }) => theme.mainTextColor};
        }

        .content-item-top {
          width: 100%;
          display: flex;
          align-items: center;
          height: 100px;
          padding: 10px 20px;

          & > *:last-child {
            margin-left: auto;
          }

          .file-input-label {
            width: 160px;
            padding: 0 10px;
            line-height: 40px;
            text-align: center;
            height: 40px;
            background-color: ${({ theme }) => theme.utilityBtnBg};
            color: #fff;
            border-radius: 10px;
            border: 1px solid;
            cursor: pointer;
            border-color: ${({ theme }) => theme.mainBorderColor};
          }

          .file-name {
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};
            padding: 0 20px;
          }

          .file-input {
            display: none;
          }
        }

        .message-container {
          width: 100%;
          display: flex;
          justify-content: space-between;
          padding: 10px 20px;

          p {
            font-size: 16px;
            font-weight: var(--font-weight-lg);
            color: ${({ theme }) => theme.mainTextColor};

            &:last-child {
              color: var(--color-red);
              text-align: right;
            }
          }
        }

        .content-item-content {
          width: 100%;

          img {
            width: 100%;
            object-fit: cover;
          }
        }
      }
    }
  }
`;
const GunlukFaturaVeDetayYukleme = () => {

  const dispatch = useDispatch();
  const { faturaImage, isLoadingFaturaYukle, isLoadingDetayYukle } =
    useSelector((state) => state.admin);
  const [faturaFile, setFaturaFile] = useState("");
  const [detayFile, setDetayFile] = useState("");
  useEffect(() => {
    dispatch(getFaturaImage());
  }, []);

  const handleFaturaSubmit = () => {
    if (faturaFile) {
      dispatch(faturaYukle(faturaFile));
    }
  };

  const handleDetaySubmit = () => {
    if (detayFile) {
      dispatch(aracBelgeAktiflikKontrol(detayFile));
    }
  };


  const handleFaturaFile = async(e) => {

      const file = await validateFile({file: e.target.files[0], maxSize: 5 * 1024 * 1024, allowedTypes:['image/jpeg', 'image/jpg', 'image/png', 'application/pdf']})
      
      if(file){
        setFaturaFile(e.target.files[0])
      }
  }

  const handleDetayFile = async(e) => {
    
    const file = await validateExcelFile({file: e.target.files[0], maxSize: 5 * 1024 * 1024, allowedTypes: ["text/csv", "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", "application/vnd.ms-excel.sheet.macroEnabled.12"]})

    if(file){
      setDetayFile(e.target.files[0])
    }
  }

  return (
    <Container>
      <div className="wrapper">
        <PageTopTitle
          title={"Günlük Fatura ve Detay Yükleme"}
          position="sticky"
        />
        <div className="content">
          <div className="content-item">
            <h2>Fatura Yükleme</h2>
            <div className="content-item-top">
              <label className="file-input-label" htmlFor="faturaFile">
                Dosya Seç
              </label>
              <div className="file-name">
                {faturaFile.name || "Dosya Seçin"}
              </div>
              <input
                type="file"
                id="faturaFile"
                className="file-input"
                onChange={handleFaturaFile}
              />
              <Btn
                color={"#E85546"}
                background={"#fff"}
                width="160px"
                radius={"10px"}
                padding="0 10px"
                handleClick={handleFaturaSubmit}
              >
                {isLoadingFaturaYukle ? (
                  <SmallSpinner
                    size={"20px"}
                    color={"#fff"}
                    bgColor={"#9ded9a"}
                  />
                ) : (
                  "Fatura Yükle"
                )}
              </Btn>
            </div>
            <div  className="content-item-content">
                {
                    faturaImage &&
                <img src={`${process.env.REACT_APP_API_IMG_URI}${faturaImage}`} alt="" />
                }
            </div>
          </div>
          <div className="content-item">
            <h2>Detay Yükleme</h2>
            <div className="content-item-top">
              <label className="file-input-label" htmlFor="detayFile">
                Dosya Seç
              </label>
              <div className="file-name">{detayFile?.name || "Dosya Seçin"}</div>
              <input
                type="file"
                id="detayFile"
                className="file-input"
                onChange={handleDetayFile}
              />
              <Btn
                color={"#E85546"}
                background={"#fff"}
                width="160px"
                radius={"10px"}
                padding="0 10px"
                handleClick={handleDetaySubmit}
              >
                {isLoadingDetayYukle ? (
                  <SmallSpinner
                    size={"20px"}
                    color={"#fff"}
                    bgColor={"#E85546"}
                  />
                ) : (
                  "Detay Yükle"
                )}
              </Btn>
            </div>
            <div className="message-container">
              <p>
                Excel den başarılı bir şekilde “Detay Listesi” yüklemek için
                lütfen excel şablonunu kullanınız.
              </p>
              <p>Detay Listesi Excel Şablonunu İndirmek İçin Tıklayınız!</p>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
};

export default GunlukFaturaVeDetayYukleme;
